import { createTheme } from '@mui/material/styles'
import { merge } from 'lodash'
import breakpoints from './breakpoints'
import { customTheme } from './themes/custom'
import { darkTheme } from './themes/dark'
import { lightTheme } from './themes/light'
import { mode_type } from './types/constants'
import typography from './typography'

const rootElement = document.getElementById('root')

const theme = createTheme({})

export function createCustomTheme(config: { palette: string; mode: string }) {
  const baseOptions = {
    shape: { borderRadius: 5 },
    typography,
    breakpoints,
    components: {
      MuiPopover: {
        defaultProps: {
          container: rootElement,
        },
      },
      MuiPopper: {
        defaultProps: {
          container: rootElement,
        },
      },
      MuiDialog: {
        defaultProps: {
          container: rootElement,
        },
      },
      MuiModal: {
        defaultProps: {
          container: rootElement,
        },
      },
    },
  }
  let themeOptions: any

  if (config.palette === mode_type.custom) {
    themeOptions = merge(baseOptions, customTheme)
  }
  if (config.palette === mode_type.light) {
    themeOptions = merge(baseOptions, lightTheme)
  }
  if (config.palette === mode_type.dark) {
    themeOptions = merge(baseOptions, darkTheme)
  }
  const theme = createTheme(themeOptions)
  return theme
}

export default theme
